// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex';
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueLazyload from 'vue-lazyload'
import E from 'wangeditor';

import { Message, Loading } from 'element-ui'; //项目已经全局引入element的话可以不单独引入

let loading        //定义loading变量

function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中……',
        background: 'rgba(255,255,255, 0.7)'
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}
//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}



Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'http://58laimi.oss-cn-zhangjiakou.aliyuncs.com/resouce/img.jpg',
  loading: 'static/dist/loading.gif',
  attempt: 1
})


/*import VueQuillEditor from 'vue-quill-editor'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)*/




import $ from 'jquery'
Vue.use(Vuex)
Vue.use(ElementUI)

Vue.prototype.$http = axios;
Vue.config.productionTip = false

router.beforeEach(function(to, from, next) {
	/*console.log(to,'dfhdsjh')*/
	if (to.query.title) {
		document.title = to.meta.title + to.query.title
	} else {
		document.title = to.meta.title
	}

	next()
})

//http request 拦截器
axios.interceptors.request.use(
    config => {
        // var token = ''
        // if(typeof Cookies.get('user') === 'undefined'){
        //     //此时为空
        // }else {
        //     token = JSON.parse(Cookies.get('user')).token
        // }//注意使用的时候需要引入cookie方法，推荐js-cookie
        // config.data = JSON.stringify(config.data);
        // config.headers = {
        //     'Content-Type':'application/json'
        // }
        // if(token != ''){
        //   config.headers.token = token;
        // }
        showFullScreenLoading()
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);
axios.interceptors.response.use(
	response => {
		if(response.data.code == 100) { // 判断是否存在token，如果存在的话，则每个http header都加上token
			/*alert(response.data.errdesc);
			window.sessionStorage.removeItem('session');*/
			router.replace({
				path: '/'
			});
			return;
		}
		//console.log('=====',response);
		tryHideFullScreenLoading()
		return response;
	},
	error => {
		if(error.response) {
			console.log('errorerror=====', error.response);
			return Promise.reject(error.response)
		}
	});



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js